/**
 * Shared B2B / B2C colour palette for client-type reports.
 * Extracted from CenterClientTypesReport so that every component
 * displaying client-type data uses the same colours.
 */

/** Named colours for known client types. */
export const CT_COLORS: Record<string, string> = {
  B2B: '#F59E0B',
  B2C: '#06C8FF',
}

/** Fallback when the type is neither B2B nor B2C. */
export const CT_DEFAULT_COLOR = '#8B5CF6'

/** Return the colour assigned to a client type key. */
export function clientTypeColor(type: string): string {
  return CT_COLORS[type] || CT_DEFAULT_COLOR
}
